<template>
  <div id="download-policy-popup" class="download-policy-popup">
    <div class="popup_div">
      <i class="close_ cubeic-close" @click="closePopup"></i>
      <p class="download-tips">为了保障投保人权益，下载电子保单需先进行短信验证：</p>
      <cube-input class="inp_" v-model="phoneNumber" readonly>
        <template #prepend>
          <span class="inp-label">投保人手机号：</span>
        </template>
      </cube-input>
      <cube-input
        class="inp_ inp_code"
        v-model="verificationCode"
        prepend="验证码："
        placeholder="请输入验证码"
      >
        <template #prepend>
          <span class="inp-label">验证码：</span>
        </template></cube-input
      >
      <div class="btn_div">
        <cube-button type="button" class="btn_ btn-download" @click="download"
          >下载电子保单</cube-button
        >
        <cube-button
          type="button"
          class="btn_ btn-sentCode"
          :disabled="countTime > 0"
          @click="sendCode"
          >{{ countTime > 0 ? countTime + 's后重试' : '获取验证码' }}</cube-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';
export default {
  name: 'download-policy-popup',
  props: {
    policyDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      phoneNumber: '',
      verificationCode: '', // 输入的验证码
      countTime: 0, // 计时时间
      hasSend: false, // 是否发送验证码
    };
  },
  watch: {
    policyDetail: function (newVal) {
      this.phoneNumber = newVal.mobile
        ? newVal.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        : '';
    },
    isShow: function () {
      this.verificationCode = '';
    },
  },
  created() {
    this.phoneNumber = this.policyDetail.mobile
      ? this.policyDetail.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      : '';
  },
  mounted() {},
  methods: {
    // 关闭下载电子保单弹窗
    closePopup() {
      this.$emit('close', '');
    },
    // 下载电子保单
    async download() {
      // this.$emit('close', this.policyDetail);
      if (!this.verificationCode) {
        this.$toast('请输入验证码');
      } else {
        // 验证验证码
        let checkFlag = await this.checkCode();
        if (checkFlag !== '0000') {
          this.$toast('验证码错误，请重新输入');
        } else {
          this.$emit('close', this.policyDetail);
          this.verificationCode = '';
        }
      }
    },
    // 获取验证码
    sendCode() {
      if (!this.policyDetail.mobile) {
        this.$toast('手机号为空');
        return;
      }
      const param = {
        phone: this.policyDetail.mobile,
        type: '1',
      };
      // 调用发送验证码接口
      api.sendVerificationCode(param).then((res) => {
        if (res.data.returnCode == '0000') {
          // 短信服务宕机下临时处理
          let data = res.data;
          const dataAll = Object.assign(data.content || {},data.data || {});
          if(dataAll && dataAll.defaultFlag && dataAll.defaultFlag == 'Y') {
            this.verificationCode = dataAll.verificationCode
          }else{
            this.$toast('验证码已发送');
          }
          this.startCountTime();
        }
      });
    },
    // 计时60秒
    startCountTime() {
      this.countTime = 60;
      let si = setInterval(() => {
        this.countTime = --this.countTime;
        if (this.countTime == 0) {
          clearInterval(si);
        }
      }, 1000);
    },
    async checkCode() {
      return new Promise((resolve, reject) => {
        //y验证验证码
        let data = {
          phone: this.policyDetail.mobile,
          verificationCode: this.verificationCode,
        };
        api
          .checkVerificationCode(data)
          .then((res) => {
            resolve(res.data.returnCode);
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style lang="scss">
.download-policy-popup {
  .popup_div {
    width: 326px;
    height: 325px;
    text-align: left;
    background: #ffffff;
    border-radius: 21px;
    position: relative;
    .close_ {
      font-size: 20px;
      color: #333333;
      position: absolute;
      top: 16px;
      right: 15px;
    }
    .download-tips {
      width: 255px;
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #292e45;
      line-height: 25px;
      margin: auto;
      padding: 41px 0 28px;
    }
    .label_ {
      padding-left: 13px;
    }
    .inp_ {
      background: #f7f7f7;
      width: 266px;
      height: 42px;
      border-radius: 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #292e45;
      line-height: 24px;
      padding: 0;
      margin: auto;
      align-items: center;
      .cube-input-field {
        padding: 0;
        height: 42px;
        background: #f7f7f7;
      }
      &.inp_code {
        margin-top: 24px;
      }
      .inp-label {
        width: auto;
        color: #292e45;
        padding-left: 13px;
        font-family: PingFang SC;
      }
    }
    .btn_div {
      display: flex;
      justify-content: center;
      text-align: center;
      margin-top: 27px;
      .btn_ {
        width: 123px;
        height: 42px;
        background: #fff3f0;
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ff3600 !important;
        line-height: 24px;
        padding: 0;
        margin: 0 !important;
        &.btn-sentCode {
          background: #ff3600;
          color: #ffffff !important;
          margin-left: 19px !important;
          &.cube-btn_disabled {
            opacity: 0.6;
          }
        }
      }
    }
  }
}
</style>
